<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
if ((navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
))) {
  window.location.href = "http://m.yiaikang.com"

}
export default {
  name: 'App'
}
</script>

<style>
/*@import '/font/font.css';*/
/*font-family: 'Alibaba', 'Avenir', Helvetica, Arial, sans-serif;*/
/*font-family: 'Alibaba';*/

#app {
  /*font-family: myFirstFont;*/
  font-family: 'AlibabaPuHuiTi', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue